// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_slug__wrapper__FSbOk"};